import type { KeyType, NoteName } from '@tunasong/schemas'

export interface Key {
  root: NoteName
  type?: KeyType // major is implied
}

/** The common scale names. We omit the theoretical ones - e.g., A# */
export const SCALE_NAMES: NoteName[] = ['C', 'C#', 'Db', 'D', 'Eb', 'E', 'F', 'F#', 'Gb', 'G', 'Ab', 'A', 'Bb', 'B']
